import React from 'react';
import { Link } from 'react-router-dom';
import { LogoFull, WhatsAppIcon } from './Logo';
import { Linkedin } from 'lucide-react';

const Footer = () => (
  <footer
    className="site-footer"
    style={{
      background: '#060b18',
      borderTop: '1px solid rgba(255,255,255,0.06)',
      padding: '64px 0 32px',
    }}
  >
    <div className="site-footer-inner max-w-7xl mx-auto px-6 md:px-12">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
        <div className="md:col-span-2">
          <LogoFull />
          <p
            style={{
              fontFamily: 'Inter, sans-serif',
              color: '#64748b',
              fontSize: '0.9rem',
              lineHeight: '1.7',
              marginTop: '16px',
              maxWidth: '320px',
            }}
          >
            Engineering intelligent digital systems that drive measurable
            business outcomes. Custom software, AI, and cloud built to scale.
          </p>
          <div className="flex gap-4 mt-6">
            <a
              href="https://www.linkedin.com/company/insightsnode/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
              style={{
                width: '38px',
                height: '38px',
                borderRadius: '50%',
                border: '1px solid rgba(255,255,255,0.12)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'rgba(255,255,255,0.5)',
                textDecoration: 'none',
                transition: 'border-color 0.2s ease, color 0.2s ease',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = '#0077b5';
                e.currentTarget.style.color = '#0077b5';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = 'rgba(255,255,255,0.12)';
                e.currentTarget.style.color = 'rgba(255,255,255,0.5)';
              }}
            >
              <Linkedin size={18} />
            </a>
            <a
              href="https://wa.me/916289350762"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp"
              style={{
                width: '38px',
                height: '38px',
                borderRadius: '50%',
                border: '1px solid rgba(37,211,102,0.25)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#25d366',
                textDecoration: 'none',
                transition: 'border-color 0.2s ease, background 0.2s ease',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = '#25d366';
                e.currentTarget.style.background = 'rgba(37,211,102,0.1)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = 'rgba(37,211,102,0.25)';
                e.currentTarget.style.background = 'transparent';
              }}
            >
              <WhatsAppIcon size={18} />
            </a>
          </div>
        </div>

        <div>
          <p className="section-label" style={{ marginBottom: '16px' }}>Pages</p>
          <nav className="flex flex-col gap-3">
            {[['Home', '/'], ['Services', '/services'], ['Work', '/work'], ['About', '/about'], ['Contact', '/contact']].map(([label, path]) => (
              <Link
                key={path}
                to={path}
                style={{
                  color: '#64748b',
                  textDecoration: 'none',
                  fontFamily: 'Inter, sans-serif',
                  fontSize: '0.875rem',
                  transition: 'color 0.2s ease',
                }}
                onMouseEnter={(e) => (e.currentTarget.style.color = '#00d4aa')}
                onMouseLeave={(e) => (e.currentTarget.style.color = '#64748b')}
              >
                {label}
              </Link>
            ))}
          </nav>
        </div>

        <div>
          <p className="section-label" style={{ marginBottom: '16px' }}>Contact</p>
          <div className="flex flex-col gap-3">
            <a
              href="mailto:hello@insightsnode.com"
              style={{ color: '#64748b', textDecoration: 'none', fontSize: '0.875rem', fontFamily: 'Inter', transition: 'color 0.2s ease' }}
              onMouseEnter={(e) => (e.currentTarget.style.color = '#00d4aa')}
              onMouseLeave={(e) => (e.currentTarget.style.color = '#64748b')}
            >
              hello@insightsnode.com
            </a>
            <a
              href="https://wa.me/916289350762"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: '#25d366', textDecoration: 'none', fontSize: '0.875rem', fontFamily: 'Inter', display: 'flex', alignItems: 'center', gap: '6px' }}
            >
              <WhatsAppIcon size={14} color="#25d366" /> Chat on WhatsApp
            </a>
            <span style={{ color: '#64748b', fontSize: '0.875rem', fontFamily: 'Inter' }}>
              Based in India • Serving clients globally
            </span>
          </div>
        </div>
      </div>

      <div
        style={{
          borderTop: '1px solid rgba(255,255,255,0.06)',
          paddingTop: '24px',
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: '12px',
        }}
      >
        <p style={{ color: '#334155', fontFamily: 'Inter', fontSize: '0.8rem' }}>
          &copy; {new Date().getFullYear()} InsightsNode. All rights reserved.
        </p>
        <p style={{ color: '#334155', fontFamily: 'JetBrains Mono, monospace', fontSize: '0.72rem', letterSpacing: '0.08em' }}>
          Engineering Intelligent Digital Systems
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
